import header from '../modules/header/index';
import presentkortJs from '../modules/presentkort';
import addScrollToTop from '../modules/addScrollToTop';
import NewsletterAction from '../modules/newsletterAction';

import "../../../scss/pages/allStyles.scss";

jQuery(function() {
  header();
  presentkortJs();
  addScrollToTop();

  $('.subscription').on('click', function() {
           
      NewsletterAction($(this));
  });
})